module.exports = __webpack_public_path__ + "static/img/gm.301e054b.svg";